export default __webpack_public_path__ + "static/media/VJA-9.11ffd2e4.webp";